import { useState } from "react";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="navbar navbar-expand-lg custom-navbar fixed-top">
      <div className="container">

        {/* LOGO */}
        <a className="navbar-brand fw-bold text-white" href="/">
          QuickID
        </a>

        {/* TOGGLE */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setOpen(!open)}
        >
          ☰
        </button>

        {/* MENU */}
        <div className={`collapse navbar-collapse ${open ? "show" : ""}`}>
          <ul className="navbar-nav ms-auto align-items-lg-center">

            <li className="nav-item">
              <a className="nav-link" href="/">Home</a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="/about">About</a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="/services">Services</a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="/faq">FAQ</a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="/contact">Contact</a>
            </li>

            {/* CTA BUTTON */}
            <li className="nav-item ms-lg-3">
              <a href="/login" className="btn btn-gradient">
                Login
              </a>
            </li>

          </ul>
        </div>

      </div>
    </nav>
  );
}
